import DataManagement from '../../containers/workspace-panel/data-management'
import { WhatNextCommonUI } from './whatNextCommonUI'
import { useSharedContext } from './../../context/shared.context'
import { useContext } from 'react'
import { WorkspaceContext } from '../../containers/workspace-panel/workspace-panel'
import { useLanguageContext } from './../../context/locale.context'

const WhatNextProgressToNext = () => {
	const {
		state: { activity },
	} = useSharedContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const { isFormEnable, openFormInWhatNext } = useContext(WorkspaceContext)

	return (
		<WhatNextCommonUI
			headerText={locale["What's next action"]}
			bodyContent={
				locale['Please submit one of the following forms to progress on this']
			}
			buttonsList={[]}
		>
			<DataManagement
				isOverviewOpen={false}
				isFromWN={true}
				isFormEnable={isFormEnable}
				activity={activity}
				onFormSelection={openFormInWhatNext}
				onDelegateFormClose={() => {}}
				isFromWhatNext={true}
			/>
		</WhatNextCommonUI>
	)
}

export { WhatNextProgressToNext }
